import { z } from "zod";

export const tutorialDtoSchema = z.object({
  id: z.number().nullable().optional(),
  airtableId: z.string().nullable().optional(),
  innizRef: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  series: z.string().nullable().optional(),
  content: z.string().nullable().optional(),
  videoUrl: z.string().nullable().optional(),
  active: z.boolean().nullable().optional(),
  premium: z.boolean().nullable().optional(),
  isInniz: z.boolean().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
});

export const tutorialsDtoSchema = z.array(tutorialDtoSchema);
